module.exports = __webpack_public_path__ + "media/images/help/new-system-page-a663d1c4dece97b7e45cdc49b1b7e3e6.png";